/**
 * Returns the best available woff2 URL for a font row.
 * Upright rows store their file in `woff2Url`.
 * Italic-only rows (separate DB row per style) store their file in `woff2UrlItalic`.
 */
export function fontWoff2Src(
  f: { woff2Url?: string | null; woff2UrlItalic?: string | null } | null | undefined,
): string | null {
  if (!f) return null
  const u = f.woff2Url || f.woff2UrlItalic
  return u && String(u).length > 0 ? String(u) : null
}
